<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="dialog-title">{{ title }}</h5>


                    <div class="reward-view flex-center-center" v-if="fromType == 1">
                        <div class="reward-item" v-tips="'JM04'">
                            <div class="reward-pic r-1"></div>
                            <div class="item-name">双11助力包</div>
                        </div>
                        <div class="reward-item">
                            <div class="reward-pic r-2"></div>
                            <div class="item-name">8折优惠券</div>
                        </div>
                    </div>


                    <div class="msg-view">
                        <p v-html="text"></p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="closeModal"></div>                       
                    </div>                    
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

.msg-view{
    color: #666565;
}

.msg-view p{
    padding: 20px 0;
    line-height: 1.8;
    text-align: center; 
}

.reward-view{
    margin-bottom: 10px;
}

.reward-item{
    width: 146px;
    margin: 10px auto;
    text-align: center;
}

.item-name{
    margin-top: 6px;
    font-size: 22px;
    color: #999999;
    text-align: center;
}

.reward-pic{
    width: 86px;
    height: 86px;
    margin: 0 auto 10px;

    &.r-1{
        background-image: url(~@/assets/images/modal/pack-share.png);
    }

    &.r-2{
        background-image: url(~@/assets/images/modal/ticket.png);
    }         
}

.reward-icon{
    width: 87px;
    height: 101px;

    &.r-1{
        background-image: url(~@/assets/images/modal/bind-gift.png);
    }     
}


.u-ctrl .u-btn.ok{
    width: 190px;
    height: 54px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/modal/btn-submit.png);     
}


</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            title : '',
            fromType : 0,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>